/**
 * Adapted fprm prosemirror-markdown.
 *
 * We only need to override the nodes and marks that are distinct form the default
 * prosemirror-markdown schema.
 *
 * See https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts
 * for how the default nodes are implemented.
 *
 */

import { Node } from "prosemirror-model";
import {
    MarkdownSerializer,
    defaultMarkdownSerializer,
} from "prosemirror-markdown";

import { EditorConfig } from "@/wc/text-editor/lib/core/config";

export const serialize = (config: EditorConfig, doc: Node) => {
    const serializerConfig = config.serializerConfig();
    return new MarkdownSerializer(
        serializerConfig.nodes,
        serializerConfig.marks,
        serializerConfig.options
    ).serialize(doc);
};

export const baseSerializerConfig = {
    nodes: defaultMarkdownSerializer.nodes,
    marks: defaultMarkdownSerializer.marks,
    options: defaultMarkdownSerializer.options,
};
